import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  template: `
<div class="input-group" :class="{ 'invalid': !valid }">
  <slot></slot>
  <validation-error :error="!valid">{{ err ? err.first(name) : '' }}</validation-error>
</div>
`
})
export class InputGroupComponent extends Vue {
  @Prop({default: false})
  err: any;

  @Prop({default: ''})
  name: string;

  @Prop
  invalid: boolean;

  get valid() {
    if (this.invalid === undefined) {
      if (this.err) {
        return !this.err.has(this.name);
      } else {
        return true;
      }
    } else {
      return !this.invalid;
    }
  }
}

Vue.component('input-group', InputGroupComponent);



// WEBPACK FOOTER //
// ./src/components/input-group/input-group.ts